import React, { ReactNode, useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./HoverTooltip.module.scss";

type TooltipPosition = "top" | "bottom" | "left" | "right";

type HoverTooltipProps = {
    icon: ReactNode;
    text: string;
    position?: TooltipPosition;
};

export const HoverTooltip: React.FC<HoverTooltipProps> = ({
    icon,
    text,
    position = "bottom"
}) => {
    const iconRef = useRef<HTMLDivElement>(null);
    const [tooltipStyle, setTooltipStyle] = useState<React.CSSProperties | null>(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (visible && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            const tooltipOffset = 8;

            const style: React.CSSProperties = {
                position: "absolute",
                top: position === "bottom" ? rect.bottom + tooltipOffset : rect.top - tooltipOffset,
                left: rect.left + rect.width / 2,
                transform: "translateX(-50%)",
                zIndex: 9999
            };

            if (position === "top") {
                style.top = rect.top - tooltipOffset;
            }

            setTooltipStyle(style);
        }
    }, [visible, position]);

    return (
        <>
            <div
                ref={iconRef}
                className={styles.wrapper}
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
            >
                {icon}
            </div>
            {visible && tooltipStyle &&
                ReactDOM.createPortal(
                    <div className={styles.portalTooltip} style={tooltipStyle}>
                        {text}
                    </div>,
                    document.body
                )}
        </>
    );
};
